// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-new-invoice-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
}
.tenant-administrator-new-invoice-container{
    width: 32vw;
    opacity: 0;
    border-radius: 5px;
    margin-bottom: 4vh;
    background-color: white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transform: translateX(-100%);
    animation: tenant-administrator-new-invoice-container-fade-in 1s ease-out forwards;
}
@keyframes tenant-administrator-new-invoice-container-fade-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    80%{
        opacity: 1;
        transform: translateX(5%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.tenant-administrator-new-invoice-header{
    color: white;
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-new-invoice-header h1{
    margin: 0px;
    font-size: 22px;
    font-weight: 600;
}
.tenant-administrator-new-invoice-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.tenant-administrator-new-invoice-body{
    position: relative;
    height: 70vh;
    box-sizing: border-box;
    overflow: hidden;
}
.tenant-administrator-new-invoice-body-navigation-bar{
    margin: 0px 25px;
    border-bottom: 1px solid rgb(226, 226, 226);
}
.tenant-administrator-new-invoice-body-navigation-bar button{
    border: none;
    padding: 0px 10px;
    padding-top: 10px;
    padding-bottom: 5px;
    cursor: pointer;
    color: rgb(100, 100, 100);
    font-size: 15px;
    font-weight: 500;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: transparent;
}
.tenant-administrator-new-invoice-body-navigation-bar button.active{
    color: rgba(155, 30, 30, 0.952);
    border-bottom: 2px solid rgba(155, 30, 30, 0.952);
}
.tenant-administrator-new-invoice-primary-details-container{
    position: absolute;
    height: 90%;
    width: 100%;
    overflow: auto;
    padding: 10px 25px;
    padding-top: 0px!important;
    box-sizing: border-box;
}
.tenant-administrator-new-invoice-primary-details-container.default{
    opacity: 1;
    z-index: 1;
    transform: translateX(0);
}
.tenant-administrator-new-invoice-primary-details-container.active{
    animation: tenant-administrator-new-invoice-primary-details-container-slide-in 0.5s ease-out forwards;
}
.tenant-administrator-new-invoice-primary-details-container.inactive{
    animation: tenant-administrator-new-invoice-primary-details-container-slide-out 0.5s ease-out forwards;
}
@keyframes tenant-administrator-new-invoice-primary-details-container-slide-in{
    from{
        opacity: 0;
        transform: translateX(100%);
    }
    to{
        opacity: 1;
        z-index: 1;
        transform: translateX(0);
    }
}
@keyframes tenant-administrator-new-invoice-primary-details-container-slide-out{
    from{
        opacity: 1;
        transform: translateX(0);
    }
    to{
        opacity: 0;
        z-index: 0;
        transform: translateX(110%);
    }
}
.tenant-administrator-new-invoice-primary-details-container::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-new-invoice-primary-details-container::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(155, 155, 155);
}
.tenant-administrator-new-invoice-entry-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-new-invoice-entry-container:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.tenant-administrator-new-invoice-entry-container p{
    margin: 0px;
    font-size: 12px;
    cursor: default;
}
.tenant-administrator-new-invoice-entry-container span{
    color: red;
}
.tenant-administrator-new-invoice-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
}
.tenant-administrator-new-invoice-selected-customer-account-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-new-invoice-selected-customer-account-container p{
    cursor: default;
    font-size: 14px;
}
.tenant-administrator-new-invoice-selected-customer-account-container p span{
    cursor: pointer;
    margin-left: 16px;
    color: rgb(80, 80, 80);
}
.tenant-administrator-new-invoice-customer-account-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    max-height: 94px;
    z-index: 1;
    display: none;
    overflow: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-new-invoice-customer-account-browser.active{
    display: block;
}
.tenant-administrator-new-invoice-customer-account-browser div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding: 10px 10px;
    cursor: pointer;
}
.tenant-administrator-new-invoice-customer-account-browser div:hover{
    background-color: rgb(243, 243, 243);
}
.tenant-administrator-new-invoice-selected-duration-type-container{
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-new-invoice-selected-duration-type-container p{
    margin: 2px 0px;
    font-size: 14px;
}
.tenant-administrator-new-invoice-selected-duration-type-container .cancel-p{
    cursor: pointer;
    color: rgb(80, 80, 80);
}
.tenant-administrator-new-invoice-duration-type-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    z-index: 1;
    max-height: 104px;
    display: none;
    overflow: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-new-invoice-duration-type-browser.active{
    display: block;
}
.tenant-administrator-new-invoice-duration-type-browser div{
    cursor: pointer;
    font-size: 14px;
    padding: 8px 10px;
}
.tenant-administrator-new-invoice-duration-type-browser div:hover{
    background-color: rgb(243, 243, 243);
}
.tenant-administrator-new-invoice-duration-type-browser::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-new-invoice-duration-type-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(100, 100, 100);
}
.tenant-administrator-new-invoice-autogenerate-container{
    display: flex;
    align-items: center;
    margin-top: -5px;
    padding: 0px 5px;
    padding-bottom: 15px;
}
.tenant-administrator-new-invoice-autogenerate-container p{
    margin: 0px;
    margin-bottom: 4px;
    font-size: 14px;
}
.tenant-administrator-new-invoice-notes-container{
    padding: 10px;
    height: 15vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-new-invoice-notes-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid lightgray;
}
.tenant-administrator-new-invoice-notes-header h3{
    margin: 0px 15px;
    font-size: 20px;
    font-weight: 500;
    cursor: default;
    color: rgb(100, 100, 100);
}
.tenant-administrator-new-invoice-notes-header p{
    margin: 0px 15px;
    font-size: 24px;
    font-weight: 500;
    cursor: pointer;
    color: rgb(100, 100, 100);
}
.tenant-administrator-new-invoice-notes-body{
    position: relative;
    overflow: auto;
    padding-top: 5px;
}
.tenant-administrator-new-invoice-notes-body::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-new-invoice-notes-body::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(128, 128, 128);
}
.tenant-administrator-new-invoice-notes-body div{
    display: flex;
    padding: 5px 0px;
    margin: 5px 10px;
    border-radius: 4px;
}
.tenant-administrator-new-invoice-notes-body div.empty{
    border: 1px solid rgba(247, 0, 0, 0.507);
}
.tenant-administrator-new-invoice-notes-body div p{
    margin: 0px;
    margin-left: 5px;
}
.tenant-administrator-new-invoice-notes-body div input{
    width: 80%;
    margin-left: 10px;
    margin-right: 40px;
    border: none;
    outline: none;
}
.tenant-administrator-new-invoice-notes-body img{
    height: 20px;
    cursor: pointer;
}

.tenant-administrator-new-invoice-subscriptions-container{
    position: absolute;
    height: 50vh;
    width: calc(100% - 50px);
    margin: 10px 25px;
    padding: 10px 15px;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
}
.tenant-administrator-new-invoice-subscriptions-container.default{
    opacity: 0;
    z-index: 0;
    transform: translateX(110%);
}
.tenant-administrator-new-invoice-subscriptions-container.active{
    animation: tenant-administrator-new-invoice-subscriptions-container-slide-in 0.5s ease-out forwards;
}
.tenant-administrator-new-invoice-subscriptions-container.inactive{
    animation: tenant-administrator-new-invoice-subscriptions-container-slide-out 0.5s ease-out forwards;
}
@keyframes tenant-administrator-new-invoice-subscriptions-container-slide-in {
    from{
        opacity: 0;
        transform: translateX(100%);
    }
    to{
        opacity: 1;
        z-index: 1;
        transform: translateX(0);
    }
}
@keyframes tenant-administrator-new-invoice-subscriptions-container-slide-out {
    from{
        opacity: 1;
        transform: translateX(0);
    }
    to{
        opacity: 0;
        z-index: 0;
        transform: translateX(110%);
    }
}
.tenant-administrator-new-invoice-subscriptions-header{
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgb(240, 240, 240);
}
.tenant-administrator-new-invoice-subscriptions-header h3{
    margin: 0px;
    font-size: 20px;
    font-weight: 500;
    cursor: default;
    color: rgb(100, 100, 100);
}
.tenant-administrator-new-invoice-subscriptions-header p{
    margin: 0px;
    font-size: 24px;
    font-weight: 500;
    cursor: pointer;
    color: rgb(100, 100, 100);
}

.tenant-administrator-new-invoice-subscription-body{
    height: 100%;
}
.tenant-administrator-new-invoice-subscriptions-no-duration-type-parent-container{
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(48, 48, 48);
}
.tenant-administrator-new-invoice-subscriptions-no-duration-type-container h2{
    font-weight: 500;
    font-size: 20px;
    text-align: center;
    margin: 10px 0px;
}
.tenant-administrator-new-invoice-subscriptions-no-duration-type-container p{
    font-size: 15px;
    margin: 0px;
}
.tenant-administrator-new-invoice-loading-available-subscriptions-parent-container{
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.tenant-administrator-new-invoice-loading-available-subscriptions-container{
    text-align: center;
}
.tenant-administrator-new-invoice-loading-available-subscriptions-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border: 2px solid rgba(0, 58, 97, 0.952);
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-new-invoice-loading-available-subscriptions-spinner 1s linear infinite;
}
@keyframes tenant-administrator-new-invoice-loading-available-subscriptions-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-new-invoice-subscription-entries-container{
    max-height: 90%;
    overflow: auto;
}
.tenant-administrator-new-invoice-subscription-entries-container::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-new-invoice-subscription-entries-container::-webkit-scrollbar{
    border-radius: 5px;
    background-color: rgb(100, 100, 100);
}
.tenant-administrator-new-invoice-subscription-entry-container{
    display: flex;
    align-items: center;
    padding: 10px;
}
.tenant-administrator-new-invoice-subscription-entry-sub-container{
    width: 100%;
    position: relative;
}
.tenant-administrator-new-invoice-subscription-entry-value-container{
    display: grid;
    grid-template-columns: 4fr 1fr;
    padding: 4px 0px;
    border-bottom: 1px solid rgb(218, 218, 218);
}
.tenant-administrator-new-invoice-subscription-entry-value-container p{
    margin: 0px;
    cursor: default;
    font-size: 14px;
}
.tenant-administrator-new-invoice-subscription-entry-value-container div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.tenant-administrator-new-invoice-subscription-entry-value-container div .remove-p{
    cursor: pointer;
    color: rgb(85, 85, 85);
}
.tenant-administrator-new-invoice-subscription-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(190, 190, 190);
}
.tenant-administrator-new-invoice-subscription-entry-container input:focus{
    border-bottom: 1px solid rgba(180, 0, 0, 0.507);
}
.tenant-administrator-new-invoice-subscription-entry-container img{
    height: 25px;
    margin-left: 10px;
    cursor: pointer;
}
.tenant-administrator-new-invoice-subscriptions-browser{
    position: absolute;
    z-index: 1;
    top: calc(100% + 2px);
    left: 0;
    width: 100%;
    display: none;
    overflow: auto;
    box-sizing: border-box;
    background-color: white;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-new-invoice-subscriptions-browser.active{
    display: block;
}
.tenant-administrator-new-invoice-subscriptions-browser div{
    cursor: pointer;
    display: grid;
    grid-template-columns: 4fr 1fr;
    border-bottom: 1px solid rgb(235, 235, 235);
}
.tenant-administrator-new-invoice-subscriptions-browser div:hover{
    background-color: rgb(235, 235, 235);
}
.tenant-administrator-new-invoice-subscriptions-browser div p{
    margin: 6px 10px;
    font-size: 14px;
    color: rgb(48, 48, 48);
}

.tenant-administrator-new-invoice-control-buttons-container{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px 25px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    box-shadow: 0px -5px 5px 0px rgba(177, 177, 177, 0.1);
}
.tenant-administrator-new-invoice-control-buttons-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 1;
}
.tenant-administrator-new-invoice-control-buttons-container button.cancel{
    color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-new-invoice-control-buttons-container button.add.active{
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-new-invoice-control-buttons-container button.add.active:hover{
    background-color: rgba(187, 36, 36, 0.952);
}
.tenant-administrator-new-invoice-control-buttons-container button.add.inactive{
    cursor: not-allowed;
    color: rgb(190, 190, 190);
}

.tenant-administrator-creating-invoice-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-creating-invoice-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border: 2px solid rgba(19, 97, 0, 0.952);
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-creating-invoice-spinner 1s linear infinite;
}
@keyframes tenant-administrator-creating-invoice-spinner {
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-creating-invoice-container p{
    margin: 10px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}


.tenant-administrator-invoice-created-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    position: relative;
    background-color: white;
}
.tenant-administrator-invoice-created-container h1{
    margin: 0px;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    cursor: default;
    color: rgb(0, 94, 8);
}
.tenant-administrator-invoice-created-container p{
    margin: 15px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
.tenant-administrator-invoice-created-okay-button-container{
    text-align: right;
}
.tenant-administrator-invoice-created-okay-button-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 5px;
    color: white;
    background-color: rgba(19, 97, 0, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-invoice-created-okay-button-container button:hover{
    background-color: rgba(27, 134, 0, 0.952);
}
.tenant-administrator-invoice-created-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-invoice-created-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-invoice-created-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-invoice-created-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}

.tenant-administrator-create-invoice-failed-container{
    text-align: center;
    padding: 16px 28px;
    padding-bottom: 12px;
    border-radius: 4px;
    position: relative;
    background-color: white;
}
.tenant-administrator-create-invoice-failed-container h1{
    margin: 0px;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 500;
    text-align: left;
    cursor: default;
    color: rgb(133, 0, 0);
}
.tenant-administrator-create-invoice-failed-container p{
    margin: 15px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
    cursor: default;
}
.tenant-administrator-create-invoice-failed-okay-button-container{
    text-align: right;
}
.tenant-administrator-create-invoice-failed-okay-button-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 5px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-create-invoice-failed-okay-button-container button:hover{
    background-color: rgba(185, 39, 39, 0.952);
}
.tenant-administrator-create-invoice-failed-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
}
.tenant-administrator-create-invoice-failed-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-create-invoice-failed-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-create-invoice-failed-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Invoices/NewInvoice.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,4DAA4D;IAC5D,4BAA4B;IAC5B,kFAAkF;AACtF;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;IAC9B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,6BAA6B;AACjC;AACA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;AAC1B;AACA;IACI,UAAU;IACV,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,qGAAqG;AACzG;AACA;IACI,sGAAsG;AAC1G;AACA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,UAAU;QACV,2BAA2B;IAC/B;AACJ;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,8CAA8C;AAClD;AACA;IACI,UAAU;IACV,UAAU;IACV,2BAA2B;AAC/B;AACA;IACI,mGAAmG;AACvG;AACA;IACI,oGAAoG;AACxG;AACA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;IACA;QACI,UAAU;QACV,UAAU;QACV,2BAA2B;IAC/B;AACJ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,sGAAsG;AAC1G;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,2CAA2C;AAC/C;AACA;IACI,+CAA+C;AACnD;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,OAAO;IACP,WAAW;IACX,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,8CAA8C;AAClD;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,qDAAqD;AACzD;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;AACA;IACI,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,wCAAwC;IACxC,6BAA6B;IAC7B,kBAAkB;IAClB,2EAA2E;AAC/E;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,8CAA8C;AAClD;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B","sourcesContent":[".tenant-administrator-new-invoice-parent-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    height: 100vh;\n    width: 100vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(0, 0, 0, 0.45);\n}\n.tenant-administrator-new-invoice-container{\n    width: 32vw;\n    opacity: 0;\n    border-radius: 5px;\n    margin-bottom: 4vh;\n    background-color: white;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    transform: translateX(-100%);\n    animation: tenant-administrator-new-invoice-container-fade-in 1s ease-out forwards;\n}\n@keyframes tenant-administrator-new-invoice-container-fade-in {\n    from{\n        opacity: 0;\n        transform: translateX(-100%);\n    }\n    80%{\n        opacity: 1;\n        transform: translateX(5%);\n    }\n    to{\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n.tenant-administrator-new-invoice-header{\n    color: white;\n    margin: 0px;\n    padding: 10px 25px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: space-between;\n    border-radius: 5px 5px 0px 0px;\n    background-color: rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-new-invoice-header h1{\n    margin: 0px;\n    font-size: 22px;\n    font-weight: 600;\n}\n.tenant-administrator-new-invoice-header p{\n    margin: 0px;\n    cursor: pointer;\n    font-size: 22px;\n    font-weight: 400;\n}\n.tenant-administrator-new-invoice-body{\n    position: relative;\n    height: 70vh;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n.tenant-administrator-new-invoice-body-navigation-bar{\n    margin: 0px 25px;\n    border-bottom: 1px solid rgb(226, 226, 226);\n}\n.tenant-administrator-new-invoice-body-navigation-bar button{\n    border: none;\n    padding: 0px 10px;\n    padding-top: 10px;\n    padding-bottom: 5px;\n    cursor: pointer;\n    color: rgb(100, 100, 100);\n    font-size: 15px;\n    font-weight: 500;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background-color: transparent;\n}\n.tenant-administrator-new-invoice-body-navigation-bar button.active{\n    color: rgba(155, 30, 30, 0.952);\n    border-bottom: 2px solid rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-new-invoice-primary-details-container{\n    position: absolute;\n    height: 90%;\n    width: 100%;\n    overflow: auto;\n    padding: 10px 25px;\n    padding-top: 0px!important;\n    box-sizing: border-box;\n}\n.tenant-administrator-new-invoice-primary-details-container.default{\n    opacity: 1;\n    z-index: 1;\n    transform: translateX(0);\n}\n.tenant-administrator-new-invoice-primary-details-container.active{\n    animation: tenant-administrator-new-invoice-primary-details-container-slide-in 0.5s ease-out forwards;\n}\n.tenant-administrator-new-invoice-primary-details-container.inactive{\n    animation: tenant-administrator-new-invoice-primary-details-container-slide-out 0.5s ease-out forwards;\n}\n@keyframes tenant-administrator-new-invoice-primary-details-container-slide-in{\n    from{\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to{\n        opacity: 1;\n        z-index: 1;\n        transform: translateX(0);\n    }\n}\n@keyframes tenant-administrator-new-invoice-primary-details-container-slide-out{\n    from{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to{\n        opacity: 0;\n        z-index: 0;\n        transform: translateX(110%);\n    }\n}\n.tenant-administrator-new-invoice-primary-details-container::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-new-invoice-primary-details-container::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(155, 155, 155);\n}\n.tenant-administrator-new-invoice-entry-container{\n    position: relative;\n    margin: 20px 0px;\n    padding: 4px 10px;\n    box-sizing: border-box;\n    border-bottom: 1px solid gray;\n    border-radius: 2px 2px 0px 0px;\n    background-color: rgba(222, 229, 233,0.6);\n}\n.tenant-administrator-new-invoice-entry-container:focus-within{\n    border-bottom: 2px solid rgb(119, 12, 12);\n    background-color: rgb(221, 232, 238);\n}\n.tenant-administrator-new-invoice-entry-container p{\n    margin: 0px;\n    font-size: 12px;\n    cursor: default;\n}\n.tenant-administrator-new-invoice-entry-container span{\n    color: red;\n}\n.tenant-administrator-new-invoice-entry-container input{\n    width: 100%;\n    outline: none;\n    border: none;\n    box-sizing: border-box;\n    background-color: transparent;\n}\n.tenant-administrator-new-invoice-selected-customer-account-container{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.tenant-administrator-new-invoice-selected-customer-account-container p{\n    cursor: default;\n    font-size: 14px;\n}\n.tenant-administrator-new-invoice-selected-customer-account-container p span{\n    cursor: pointer;\n    margin-left: 16px;\n    color: rgb(80, 80, 80);\n}\n.tenant-administrator-new-invoice-customer-account-browser{\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 0;\n    width: 100%;\n    max-height: 94px;\n    z-index: 1;\n    display: none;\n    overflow: auto;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-new-invoice-customer-account-browser.active{\n    display: block;\n}\n.tenant-administrator-new-invoice-customer-account-browser div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 14px;\n    padding: 10px 10px;\n    cursor: pointer;\n}\n.tenant-administrator-new-invoice-customer-account-browser div:hover{\n    background-color: rgb(243, 243, 243);\n}\n.tenant-administrator-new-invoice-selected-duration-type-container{\n    display: flex;\n    justify-content: space-between;\n}\n.tenant-administrator-new-invoice-selected-duration-type-container p{\n    margin: 2px 0px;\n    font-size: 14px;\n}\n.tenant-administrator-new-invoice-selected-duration-type-container .cancel-p{\n    cursor: pointer;\n    color: rgb(80, 80, 80);\n}\n.tenant-administrator-new-invoice-duration-type-browser{\n    position: absolute;\n    top: calc(100% + 2px);\n    left: 0;\n    width: 100%;\n    z-index: 1;\n    max-height: 104px;\n    display: none;\n    overflow: auto;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-new-invoice-duration-type-browser.active{\n    display: block;\n}\n.tenant-administrator-new-invoice-duration-type-browser div{\n    cursor: pointer;\n    font-size: 14px;\n    padding: 8px 10px;\n}\n.tenant-administrator-new-invoice-duration-type-browser div:hover{\n    background-color: rgb(243, 243, 243);\n}\n.tenant-administrator-new-invoice-duration-type-browser::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-new-invoice-duration-type-browser::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(100, 100, 100);\n}\n.tenant-administrator-new-invoice-autogenerate-container{\n    display: flex;\n    align-items: center;\n    margin-top: -5px;\n    padding: 0px 5px;\n    padding-bottom: 15px;\n}\n.tenant-administrator-new-invoice-autogenerate-container p{\n    margin: 0px;\n    margin-bottom: 4px;\n    font-size: 14px;\n}\n.tenant-administrator-new-invoice-notes-container{\n    padding: 10px;\n    height: 15vh;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-new-invoice-notes-header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid lightgray;\n}\n.tenant-administrator-new-invoice-notes-header h3{\n    margin: 0px 15px;\n    font-size: 20px;\n    font-weight: 500;\n    cursor: default;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-new-invoice-notes-header p{\n    margin: 0px 15px;\n    font-size: 24px;\n    font-weight: 500;\n    cursor: pointer;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-new-invoice-notes-body{\n    position: relative;\n    overflow: auto;\n    padding-top: 5px;\n}\n.tenant-administrator-new-invoice-notes-body::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-new-invoice-notes-body::-webkit-scrollbar-thumb{\n    border-radius: 5px;\n    background-color: rgb(128, 128, 128);\n}\n.tenant-administrator-new-invoice-notes-body div{\n    display: flex;\n    padding: 5px 0px;\n    margin: 5px 10px;\n    border-radius: 4px;\n}\n.tenant-administrator-new-invoice-notes-body div.empty{\n    border: 1px solid rgba(247, 0, 0, 0.507);\n}\n.tenant-administrator-new-invoice-notes-body div p{\n    margin: 0px;\n    margin-left: 5px;\n}\n.tenant-administrator-new-invoice-notes-body div input{\n    width: 80%;\n    margin-left: 10px;\n    margin-right: 40px;\n    border: none;\n    outline: none;\n}\n.tenant-administrator-new-invoice-notes-body img{\n    height: 20px;\n    cursor: pointer;\n}\n\n.tenant-administrator-new-invoice-subscriptions-container{\n    position: absolute;\n    height: 50vh;\n    width: calc(100% - 50px);\n    margin: 10px 25px;\n    padding: 10px 15px;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);\n}\n.tenant-administrator-new-invoice-subscriptions-container.default{\n    opacity: 0;\n    z-index: 0;\n    transform: translateX(110%);\n}\n.tenant-administrator-new-invoice-subscriptions-container.active{\n    animation: tenant-administrator-new-invoice-subscriptions-container-slide-in 0.5s ease-out forwards;\n}\n.tenant-administrator-new-invoice-subscriptions-container.inactive{\n    animation: tenant-administrator-new-invoice-subscriptions-container-slide-out 0.5s ease-out forwards;\n}\n@keyframes tenant-administrator-new-invoice-subscriptions-container-slide-in {\n    from{\n        opacity: 0;\n        transform: translateX(100%);\n    }\n    to{\n        opacity: 1;\n        z-index: 1;\n        transform: translateX(0);\n    }\n}\n@keyframes tenant-administrator-new-invoice-subscriptions-container-slide-out {\n    from{\n        opacity: 1;\n        transform: translateX(0);\n    }\n    to{\n        opacity: 0;\n        z-index: 0;\n        transform: translateX(110%);\n    }\n}\n.tenant-administrator-new-invoice-subscriptions-header{\n    padding-bottom: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid rgb(240, 240, 240);\n}\n.tenant-administrator-new-invoice-subscriptions-header h3{\n    margin: 0px;\n    font-size: 20px;\n    font-weight: 500;\n    cursor: default;\n    color: rgb(100, 100, 100);\n}\n.tenant-administrator-new-invoice-subscriptions-header p{\n    margin: 0px;\n    font-size: 24px;\n    font-weight: 500;\n    cursor: pointer;\n    color: rgb(100, 100, 100);\n}\n\n.tenant-administrator-new-invoice-subscription-body{\n    height: 100%;\n}\n.tenant-administrator-new-invoice-subscriptions-no-duration-type-parent-container{\n    height: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: rgb(48, 48, 48);\n}\n.tenant-administrator-new-invoice-subscriptions-no-duration-type-container h2{\n    font-weight: 500;\n    font-size: 20px;\n    text-align: center;\n    margin: 10px 0px;\n}\n.tenant-administrator-new-invoice-subscriptions-no-duration-type-container p{\n    font-size: 15px;\n    margin: 0px;\n}\n.tenant-administrator-new-invoice-loading-available-subscriptions-parent-container{\n    height: 80%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.tenant-administrator-new-invoice-loading-available-subscriptions-container{\n    text-align: center;\n}\n.tenant-administrator-new-invoice-loading-available-subscriptions-container div{\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    border: 2px solid rgba(0, 58, 97, 0.952);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-new-invoice-loading-available-subscriptions-spinner 1s linear infinite;\n}\n@keyframes tenant-administrator-new-invoice-loading-available-subscriptions-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-new-invoice-subscription-entries-container{\n    max-height: 90%;\n    overflow: auto;\n}\n.tenant-administrator-new-invoice-subscription-entries-container::-webkit-scrollbar{\n    width: 4px;\n}\n.tenant-administrator-new-invoice-subscription-entries-container::-webkit-scrollbar{\n    border-radius: 5px;\n    background-color: rgb(100, 100, 100);\n}\n.tenant-administrator-new-invoice-subscription-entry-container{\n    display: flex;\n    align-items: center;\n    padding: 10px;\n}\n.tenant-administrator-new-invoice-subscription-entry-sub-container{\n    width: 100%;\n    position: relative;\n}\n.tenant-administrator-new-invoice-subscription-entry-value-container{\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n    padding: 4px 0px;\n    border-bottom: 1px solid rgb(218, 218, 218);\n}\n.tenant-administrator-new-invoice-subscription-entry-value-container p{\n    margin: 0px;\n    cursor: default;\n    font-size: 14px;\n}\n.tenant-administrator-new-invoice-subscription-entry-value-container div{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.tenant-administrator-new-invoice-subscription-entry-value-container div .remove-p{\n    cursor: pointer;\n    color: rgb(85, 85, 85);\n}\n.tenant-administrator-new-invoice-subscription-entry-container input{\n    width: 100%;\n    outline: none;\n    border: none;\n    box-sizing: border-box;\n    border-bottom: 1px solid rgb(190, 190, 190);\n}\n.tenant-administrator-new-invoice-subscription-entry-container input:focus{\n    border-bottom: 1px solid rgba(180, 0, 0, 0.507);\n}\n.tenant-administrator-new-invoice-subscription-entry-container img{\n    height: 25px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n.tenant-administrator-new-invoice-subscriptions-browser{\n    position: absolute;\n    z-index: 1;\n    top: calc(100% + 2px);\n    left: 0;\n    width: 100%;\n    display: none;\n    overflow: auto;\n    box-sizing: border-box;\n    background-color: white;\n    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);\n}\n.tenant-administrator-new-invoice-subscriptions-browser.active{\n    display: block;\n}\n.tenant-administrator-new-invoice-subscriptions-browser div{\n    cursor: pointer;\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n    border-bottom: 1px solid rgb(235, 235, 235);\n}\n.tenant-administrator-new-invoice-subscriptions-browser div:hover{\n    background-color: rgb(235, 235, 235);\n}\n.tenant-administrator-new-invoice-subscriptions-browser div p{\n    margin: 6px 10px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n}\n\n.tenant-administrator-new-invoice-control-buttons-container{\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    padding: 10px 25px;\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    box-shadow: 0px -5px 5px 0px rgba(177, 177, 177, 0.1);\n}\n.tenant-administrator-new-invoice-control-buttons-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    z-index: 1;\n}\n.tenant-administrator-new-invoice-control-buttons-container button.cancel{\n    color: rgba(155, 30, 30, 0.952);\n}\n.tenant-administrator-new-invoice-control-buttons-container button.add.active{\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.tenant-administrator-new-invoice-control-buttons-container button.add.active:hover{\n    background-color: rgba(187, 36, 36, 0.952);\n}\n.tenant-administrator-new-invoice-control-buttons-container button.add.inactive{\n    cursor: not-allowed;\n    color: rgb(190, 190, 190);\n}\n\n.tenant-administrator-creating-invoice-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    background-color: white;\n}\n.tenant-administrator-creating-invoice-container div{\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    border: 2px solid rgba(19, 97, 0, 0.952);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-creating-invoice-spinner 1s linear infinite;\n}\n@keyframes tenant-administrator-creating-invoice-spinner {\n    from{\n        transform: rotate(0deg);\n    }\n    to{\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-creating-invoice-container p{\n    margin: 10px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n\n\n.tenant-administrator-invoice-created-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    position: relative;\n    background-color: white;\n}\n.tenant-administrator-invoice-created-container h1{\n    margin: 0px;\n    margin-top: 5px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: left;\n    cursor: default;\n    color: rgb(0, 94, 8);\n}\n.tenant-administrator-invoice-created-container p{\n    margin: 15px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n.tenant-administrator-invoice-created-okay-button-container{\n    text-align: right;\n}\n.tenant-administrator-invoice-created-okay-button-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 5px;\n    color: white;\n    background-color: rgba(19, 97, 0, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.tenant-administrator-invoice-created-okay-button-container button:hover{\n    background-color: rgba(27, 134, 0, 0.952);\n}\n.tenant-administrator-invoice-created-escape-button-container{\n    position: absolute;\n    top: 0px;\n    right: -60px;\n    cursor: pointer;\n}\n.tenant-administrator-invoice-created-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.tenant-administrator-invoice-created-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.tenant-administrator-invoice-created-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}\n\n.tenant-administrator-create-invoice-failed-container{\n    text-align: center;\n    padding: 16px 28px;\n    padding-bottom: 12px;\n    border-radius: 4px;\n    position: relative;\n    background-color: white;\n}\n.tenant-administrator-create-invoice-failed-container h1{\n    margin: 0px;\n    margin-top: 5px;\n    font-size: 20px;\n    font-weight: 500;\n    text-align: left;\n    cursor: default;\n    color: rgb(133, 0, 0);\n}\n.tenant-administrator-create-invoice-failed-container p{\n    margin: 15px 0px;\n    font-size: 14px;\n    color: rgb(48, 48, 48);\n    cursor: default;\n}\n.tenant-administrator-create-invoice-failed-okay-button-container{\n    text-align: right;\n}\n.tenant-administrator-create-invoice-failed-okay-button-container button{\n    border: none;\n    cursor: pointer;\n    padding: 8px 20px;\n    border-radius: 5px;\n    color: white;\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: background-color 0.25s ease-in-out;\n}\n.tenant-administrator-create-invoice-failed-okay-button-container button:hover{\n    background-color: rgba(185, 39, 39, 0.952);\n}\n.tenant-administrator-create-invoice-failed-escape-button-container{\n    position: absolute;\n    top: 0px;\n    right: -60px;\n    cursor: pointer;\n}\n.tenant-administrator-create-invoice-failed-escape-button-container:hover button{\n    color: rgb(96, 96, 96);\n}\n.tenant-administrator-create-invoice-failed-escape-button-container button{\n    border: none;\n    font-size: 20px;\n    padding: 10px 16px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: white;\n    color: rgb(175, 175, 175);\n    transition: color 0.25s ease;\n}\n.tenant-administrator-create-invoice-failed-escape-button-container p{\n    margin: 5px 0px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: 900;\n    cursor: pointer;\n    color: rgb(240, 240, 240);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
